var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInCircleOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5143",
    "data-name": "Rectangle 5143",
    width: 14.816,
    height: 14.954,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13369",
    "data-name": "Group 13369",
    transform: "translate(-1482 -401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13232",
    "data-name": "Group 13232",
    transform: "translate(1482 400.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0.167)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.375,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13343",
    "data-name": "Group 13343",
    transform: "translate(1486.438 405.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13342",
    "data-name": "Group 13342",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420-2",
    "data-name": "Ellipse 420",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(-0.438 -0.27)",
    fill: "#286cb5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13243",
    "data-name": "Group 13243",
    transform: "translate(5.917 5.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13242",
    "data-name": "Group 13242",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45466",
    "data-name": "Path 45466",
    d: "M83.437,77.567a3.138,3.138,0,0,1,1.909-1.236c6-1.167,4.521,5.97,4.707,9.553a.5.5,0,0,1-.534.491,15.53,15.53,0,0,1-2.239,0,.443.443,0,0,1-.444-.441c-.136-1.505.344-5.138-.333-6.283a1.586,1.586,0,0,0-2.554-.15c-.986,1.185-.409,4.821-.556,6.433a.443.443,0,0,1-.444.441,15.267,15.267,0,0,1-2.193,0,.507.507,0,0,1-.488-.444l.012-9.169c.058-.168.147-.331.342-.357.759.064,1.683-.1,2.422,0a.5.5,0,0,1,.394.445Z",
    transform: "translate(-75.272 -71.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45467",
    "data-name": "Path 45467",
    d: "M9.926,88.7a.752.752,0,0,1-.381.154,14.49,14.49,0,0,1-2.144,0,.538.538,0,0,1-.477-.408l-.012-9.122a.548.548,0,0,1,.36-.432c.731.062,1.709-.118,2.41-.007a.457.457,0,0,1,.342.31l.012,9.171a.584.584,0,0,1-.11.333",
    transform: "translate(-6.481 -73.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45468",
    "data-name": "Path 45468",
    d: "M1.772.016c2.681-.307,3.056,3.749.495,4.035A2.033,2.033,0,0,1,1.772.016",
    transform: "translate(0 0)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInCircleOrange);
export default __webpack_public_path__ + "static/media/linkedIn-circle-orange.6228699d20398f0d6e94f4de236bbeb3.svg";
export { ForwardRef as ReactComponent };